import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './Navbar.css';

export default function Navbar({ onCartOpen }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { count } = useCart();
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  return (
    <header className={`navbar ${scrolled || !isHome ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>
      <div className="navbar-inner">
        <button className="nav-menu-btn" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          <span /><span /><span />
        </button>

        <Link to="/" className="navbar-logo">
          <span className="logo-text">Alainn</span>
  
        </Link>

        <div className="navbar-actions">
          <button className="cart-btn" onClick={onCartOpen} aria-label="Open cart">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
              <line x1="3" y1="6" x2="21" y2="6"/>
              <path d="M16 10a4 4 0 01-8 0"/>
            </svg>
            {count > 0 && <span className="cart-count">{count}</span>}
          </button>
        </div>
      </div>

      <nav className={`mobile-nav ${menuOpen ? 'open' : ''}`}>
        <Link to="/" className="mobile-nav-link">Home</Link>
        <Link to="/shop" className="mobile-nav-link">Shop</Link>
        <Link to="/shop?cat=Dresses" className="mobile-nav-link">Dresses</Link>
        <Link to="/shop?cat=Outerwear" className="mobile-nav-link">Outerwear</Link>
        <Link to="/shop?cat=Accessories" className="mobile-nav-link">Accessories</Link>
      </nav>

      <nav className="desktop-nav">
        <Link to="/shop" className="nav-link">Shop</Link>
        <Link to="/shop?cat=Dresses" className="nav-link">Dresses</Link>
        <Link to="/shop?cat=Outerwear" className="nav-link">Outerwear</Link>
        <Link to="/shop?cat=Accessories" className="nav-link">Accessories</Link>
      </nav>
    </header>
  );
}
